import React, { useContext, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import DF from 'DisplayFramework';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import DataGrid from 'components/DataGrid';
import { Col, notification, Popconfirm, Row } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import DeleteButton from 'components/DeleteButton';
import Button from 'components/Button';
import {
  deleteParassetfvcontext,
  getParassetfvcontextByCriteria,
  GetParassetfvcontextByCriteriaParams,
  ParassetfvcontextResponse,
} from 'services/assetconfig';
import ParListSelect from 'components/ParListSelect';
import ProductInput from 'pages/ProposalV3/PropDetail/ProductInput';
import OfferInput from 'pages/Configuration/Management/ParametersFiltering/OfferInput';
import ParAssetFVContextDetails from '../ParAsset/AssetFutureValueContext/ParAssetFVContextDetails';
import ModalControllerNV from 'components/ModalControllerNV';
import { AuthContext } from 'components/Auth/Auth';
import ButtonComponent from 'components/Button';
import TasksListPopover from 'pages/workflow/TasksListPopover';
import IActions from 'icons/IActions';
type AssetFutureValueListprops = {
  asset: any;
  catalogid: any;
  isModal?: string;
};
const AssetFutureValueList = (props: AssetFutureValueListprops) => {
  const { asset, catalogid, isModal } = props;
  const { isInspect } = useContext(AuthContext);
  const initialSearchParams: GetParassetfvcontextByCriteriaParams = {
    assetcategory: asset.assetcategory ?? ('' as any),
    assetfamily: asset.assetfamily ?? ('' as any),
    assettype: asset.assettype ?? ('' as any),
    assetmodel: asset.assetmodel ?? ('' as any),
    assetsegment: asset.assetsegment ?? ('' as any),
    offerid: '' as any,
    parcontextid: '' as any,
    prcode: '' as any,
    catalogid: catalogid ?? ('' as any),
    contextcode: '' as any,
    contextorigin: '' as any,
    contextstatus: '' as any,
  };
  const [searchParams, setSearchParams] =
    useState<GetParassetfvcontextByCriteriaParams>(initialSearchParams);
  const {
    data: fvcontextlist,
    refetch,
    isFetching,
  } = useQuery(['getParassetfvcontextByCriteria', searchParams], () =>
    getParassetfvcontextByCriteria(searchParams).then((res) => {
      return res.list || [];
    })
  );
  const [prrcode, setPrcode] = useState<any>('');

  const columns = useMemo<DataGridColDef<ParassetfvcontextResponse>[]>(
    () => [
      {
        dataIndex: 'parcontextid',
        width: '50px',
      },
      {
        dataIndex: 'contextcodelabel',
        width: '50px',
        filtrable: 'contextcode',
        filterComponent: <ParListSelect parcode="FVCONTEXT" />,
        render: (value, record, index) => (
          <ModalControllerNV
            modal={({ setVisible, visible }) => (
              <ParAssetFVContextDetails
                parcontextid={record.parcontextid}
                refetch={refetch}
                onCancel={() => setVisible(false)}
                showAsModal
                catalog={asset}
                visible={visible}
              />
            )}
            content={({ setVisible, visible }) => (
              <a onClick={() => setVisible(true)}>{value}</a>
            )}
          />
        ),
      },

      {
        dataIndex: 'prcode',
        width: '50px',
        filtrable: true,
        filterComponent: (
          <ProductInput
            onSelect={(e) => {
              setPrcode(e);
            }}
          />
        ),
      },

      {
        dataIndex: 'offerlabel',
        width: '100px',
        filtrable: 'offerid',
        filterComponent: (
          <OfferInput
            params={{
              prcode: String(prrcode),
              mgid: Number(localStorage.getItem('mgid')),
            }}
          />
        ),
      },
      {
        dataIndex: 'ofrtypelabel',
        width: '50px',
      },

      {
        dataIndex: 'contextoriginlabel',
        width: '50px',
        filtrable: 'contextorigin',
        filterComponent: <ParListSelect parcode="FVCTXORIG" />,
      },
      {
        dataIndex: 'durationmin',
        width: '50px',
      },
      {
        dataIndex: 'durationmax',
        width: '50px',
      },

      {
        dataIndex: 'contextstatuslabel',
        width: '50px',
        filtrable: 'contextstatus',
        filterComponent: <ParListSelect parcode="STATUS" />,
      },

      {
        dataIndex: 'Actions',
        width: '70px',
        fixed: 'right',
        render: (value, record, index) => (
          <Row>
            <Col>
              <TasksListPopover
                entityId={record?.parcontextid}
                entityName="FVCONTEXT"
                title={record?.contextcodelabel}
                onClose={refetch}
              >
                <ButtonComponent
                  icon={<IActions height="15px" width="15px" />}
                  comcode="actions"
                  style={{
                    height: 40,
                    marginBottom: 6,
                  }}
                />
              </TasksListPopover>
            </Col>
           
            <Col>
              <Popconfirm
                title="Sure to delete?"
                onConfirm={() => {
                  deleteParassetfvcontext({
                    contextid: record.parcontextid,
                  }).then((res) => {
                    notification.success({ message: res.message });
                    refetch();
                  });
                }}
              >
                <DeleteButton onlyIcon />
              </Popconfirm>
            </Col>
          </Row>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParams, fvcontextlist, refetch, prrcode, isInspect]
  );

  return (
    <DF.Provider pagcode="parassetfvcontext">
      <DataGrid
        isLoading={isFetching}
        rowKey={(record) => record.parcontextid}
        size="small"
        pagination={{ pageSize: 10 }}
        scroll={{ x: 1700, y: 700 }}
        columns={columns}
        dataSource={fvcontextlist}
        initialSearchValues={initialSearchParams}
        titleComcode="AssetFutureValueContextList"
        onSearch={(value) => {
          setSearchParams({
            ...value,
          });
        }}
        hideExtraAction={!!isModal}
        extraActions={
          <ModalControllerNV
            modal={({ setVisible, visible }) => (
              <ParAssetFVContextDetails
                onCancel={() => setVisible(false)}
                refetch={refetch}
                showAsModal
                visible={visible}
                catalog={asset}
              />
            )}
            content={({ setVisible, visible }) => (
              <Button
                type="primary"
                icon={
                  <PlusOutlined onClick={() => isInspect && setVisible(true)} />
                }
                onClick={() => !isInspect && setVisible(true)}
                comcode="Add"
              />
            )}
          />
        }
      />
    </DF.Provider>
  );
};

export default AssetFutureValueList;
